import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const LetterWord = ({ word, reveal, hide }) => {
	const letters = [...word];

	return (
		<motion.span
			key={word}
			initial='hidden'
			animate='show'
			exit='exit'
			variants={{
				show: {
					transition: {
						staggerChildren: reveal / 1000 / letters.length
					}
				}
			}}
			style={{ display: 'inline-flex' }}
		>
			{letters.map((char, i) => (
				<motion.span
					key={i}
					variants={{
						hidden: {
							x: -24,
							opacity: 0,
							filter: 'blur(6px)'
						},
						show: {
							x: 0,
							opacity: 1,
							filter: 'blur(0px)',
							transition: {
								duration: reveal / 1000,
								ease: [0.22, 1, 0.36, 1]
							}
						},
						exit: {
							x: 20,
							opacity: 0,
							filter: 'blur(4px)',
							transition: {
								duration: hide / 1000,
								ease: 'easeIn'
							}
						}
					}}
					style={{ display: 'inline-block' }}
				>
					{char === ' ' ? '\u00A0' : char}
				</motion.span>
			))}
		</motion.span>
	);
};

export const GraphPulseWord = ({
	words = ['Creative', 'Powerful', 'Reliable'],
	reveal = 700,
	pause = 1600,
	hide = 500,
	className = ''
}) => {
	const [index, setIndex] = useState(0);
	const total = reveal + pause + hide;

	useEffect(() => {
		if (!words.length) return;

		const timer = setInterval(() => {
			setIndex(prev => (prev + 1) % words.length);
		}, total);

		return () => clearInterval(timer);
	}, [words.length, total]);

	return (
		<div
			key={index} 
			className={`graphEffect ${className}`}
			style={{ '--cycle': `${total}ms` }}
		>
			<AnimatePresence mode='wait'>
				<LetterWord
					key={words[Number(index)]}
					word={words[Number(index)]}
					reveal={reveal}
					hide={hide}
				/>
			</AnimatePresence>
		</div>
	);
};
